
import React, { useEffect, useState, useRef, useCallback } from "react";
import cn from "classnames";
import styles from "./ServiceRequest.module.scss";
import Master from "screen/Master";
import Table from "../../components/common/Table";
import { getRequest, patchRequest } from "../../services/axiosBaseClient";
import { getRequestInAssets } from "services/axiosAssetsBaseClient";
import { Link } from "react-router-dom";
var readOnlyField = true;


function ServiceRequestView(props) {
    const id = props.match.params.id;
    const view = props.match.params.view;

  const initialFormValues = {
    category: "",
    asset: "",
    reference_Id: "",
    description: ""

  };

  const [category, setcategory] = useState("");
  const [asset, setasset] = useState("");
  const [reference_Id, setreference_Id] = useState("");
  const [description, setdescription] = useState("");
  // const [listingData, setListingData] = useState('');
  // const [createData, setCreateData] = useState('');
  const [formValues,setFormValues] = useState('');

  const handleSubmit = (e) => {
    // alert([category, asset, reference_Id, description])
    e.preventDefault();
  }
  const columns = React.useMemo(() => [
    {
      Header: "Request ID",
      accessor: "reference_Id",
    },
    {
      Header: "Category of Issues ",
      accessor: "category",
    },
    {
      Header: "Asset",
      accessor: "asset",
    },
    {
      Header: 'Status',
      accessor: (row) => {
        return (
          <>
            {
              row?.status === 'CREATED'
                ? (
                  <p className={cn(styles.Status1)}>
                    <span>
                      Created
                    </span>
                  </p>
                ) : ""
            }

            {
              row?.status === 'BLOCKED'
                ? (
                  <p className={cn(styles.Status1, styles.Status2)}>
                    <span>
                      Blocked
                    </span>
                  </p>
                ) : ""
            }

            {
              row?.status === 'CLOSED'
                ? (
                  <p className={cn(styles.Status1, styles.Status3)}>
                    <span>
                      Closed
                    </span>
                  </p>
                ) : ""
            }


          </>
        )
      }

    },
    {
      Header: 'Action',
      accessor: 'zoneId',
      disableSortBy: true,
      Cell: (row) => {
        return (
          <>
            <div>
              <img
                src={require("assets/eye.png").default}
                className={cn(styles.Img)}
                
              ></img>
              <img
                src={require("assets/pencil.png").default}
                className={cn(styles.Img)}
              ></img>
            </div>
          </>
        );
      }
    },
  ]);
  var listingData = [
    {
      "id": 1,
      "category": "test",
      "reference_Id": "BT01",
      "asset": "BATTERY",
      "createdAt": 1655768305626,
      "updatedAt": 1655768305626,
      "status": "CREATED",
      "description": "description",
      "count":1
    },
  ];

  var createData = [
    {
      "id": 47,
      "category": "string",
      "reference_Id": "string12",
      "asset": "BATTERY",
      "createdAt": 5657221,
      "updatedAt": 3862732,
      "status": "CREATED",
      "description": "string1223"
  },
  ]
let Urls = window.location.href.toString().split(window.location.host)[1];
console.log("++++",Urls);
console.log("-----",createData[0].reference_Id);
  return (
    <>
      <div className={cn(styles.flex_item1)}>
        <div className={cn(styles.flex1)}>
          <h2 className={cn(styles.medium_title, styles.medium_title_layout)}>
            {"Service Request"}
          </h2>
          <div className={cn(styles.block1)}>
            <div className={cn(styles.Insideblock1)}>


              <div className={cn(styles.title)}>
                {Urls === "/ServiceRequest/ViewService/BT01/:view"? "View Service Request":"Update Service Request"}
              </div>
              <hr className={cn(styles.line)} />
              <div>
                <div className={cn(styles.flex4, styles.flex4_layout)}>


                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                      <div
                        className={cn(
                          styles.text1_body,
                          styles.text1_body_layout
                        )}
                      >
                        {"Category of Issue *"}
                      </div>
                    </div>
                  </div>

                  <div className={cn(styles.flex4_spacer)} />
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                      <div>
                        
                        <select className={cn(styles.select1)} value={formValues.category}
                          onChange={e => setcategory(e.target.value)}>
                          {/* <option value="1" selected>Select category</option> */}
                          {createData.map((obj) => {
                            return <option value={obj.id}>{obj.category}</option>;
                          })}
                          {/* <option value="2" >Site 2</option> */}
                        </select>
                      </div>
                    </div>

                  </div>
                </div>


                <div className={cn(styles.flex4, styles.flex4_layout)}>
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                      <div
                        className={cn(
                          styles.text1_body,
                          styles.text1_body_layout
                        )}
                      >
                        {"Select Asset *"}
                      </div>
                    </div>
                  </div>

                  <div className={cn(styles.flex4_spacer)} />
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                      <div>
                        <select className={cn(styles.select1)} value={formValues.asset}
                          onChange={e => setasset(e.target.value)}>
                          {/* <option value="1" selected>Select asset.</option> */}
                          {createData.map((obj) => {
                            return <option value={obj.id}>{obj.asset}</option>;
                          })}
                          {/* <option value="2" >Battery2</option> */}
                        </select>
                      </div>
                    </div>
                  </div>
                </div>

                <div className={cn(styles.flex4, styles.flex4_layout)}>


                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                      <div
                        className={cn(
                          styles.text1_body,
                          styles.text1_body_layout
                        )}
                      >
                        {"Reference ID *"}
                      </div>
                    </div>
                  </div>

                  <div className={cn(styles.flex4_spacer)} />
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                      <div>
                        <input
                          name="id"
                          value={createData[0].reference_Id}
                          onChange={e => setreference_Id(e.target.value)}
                          className={cn(styles.select1)}
                        //  value={formValues.ID}
                        // disabled={readOnlyField}
                        />
                        {/* <input type="submit" value="Submit" /> */}

                      </div>
                    </div>

                  </div>
                </div>


                <div className={cn(styles.flex4, styles.flex4_layout)}>


                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                      <div
                        className={cn(
                          styles.text1_body,
                          styles.text1_body_layout
                        )}
                      >
                        {"Discription"}
                      </div>
                    </div>
                  </div>

                  <div className={cn(styles.flex4_spacer)} />
                  <div className={cn(styles.flex2_item)}>
                    <div className={cn(styles.block3, styles.block3_layout)}>
                      <div>
                        {/* <div
                          className={cn(
                            styles.text2_body,
                            styles.text2_body_layout
                          )}
                        >
                          {"Battery charging fail"}</div> */}
                        {/* <input 
                          name="Description"
                          value={createData[0].description}
                          onChange={e => setdescription(e.target.value)}
                          className={cn(styles.select2)}
                          maxLength={400}
                          minLength={30}
                        /> */}
                        <textarea
                        
                        name="Description"
                          value={createData[0].description}
                          onChange={e => setdescription(e.target.value)}
                          // className={cn(styles.select2)}
                          maxLength={400}
                          minLength={30}
                        >

                        </textarea>
                        <div
                          className={cn(
                            styles.text3_body,
                            styles.text3_body_layout
                          )}
                        >
                          {"33 Characters (maximum 400 characters)"}</div>

                      </div>

                    </div>

                  </div>
                </div>


              </div>


              <div className={cn(styles.flex9, styles.flex9_layout)}>
                <div className={cn(styles.flex9_item)}>
                  <Link to='/ServiceRequest'>
                  <div className={cn(styles.block7, styles.block7_layout)}>
                    <h5 className={cn(styles.highlights1, styles.highlights1_layout)}>
                      {'Cancel'}
                    </h5>
                  </div>
                  </Link>
                  
                </div>
                <div className={cn(styles.flex9_spacer)} />
                <div className={cn(styles.flex9_item)}>
                  <div className={cn(styles.block8, styles.block8_layout)}>
                    <h5 className={cn(styles.highlights2, styles.highlights2_layout)} onClick={handleSubmit}>
                      {'Submit'}
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={cn(styles.box16, styles.box16_layout)}>
            <div className={cn(styles.header)}>
              <div className={cn(styles.header1)}>
                {"Tickets "}
              </div>

              <div className={cn(styles.Subheader)}>
                <div className={cn(styles.header2)}>
                  {"Total Tickets :"}
                </div>

                <div className={cn(styles.header3)}>
                  {" 31"}
                  {listingData[0].count}
                </div>
              </div>
            </div>

            <Table
              columns={columns}
              // data={ServiceRequestData}
              data={listingData}
            />
          </div>
        </div>
      </div>
    </>
  );
}
let Urls = window.location.href.toString().split(window.location.host)[1];
export default function ServiceRequest(props) {
  return (
    <>
      <Master
        ServiceRequesturl={Urls}
        opts={props}
        screen={ServiceRequestView}
        showStatus={true}
      />
    </>
  );
}

ServiceRequest.inStorybook = true;